// Function to detect if user is in India based on IP address
function isInIndia() {
    // Make an API call to get user's IP address
    fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => {
        // Make an API call to get user's country based on IP address
        fetch(`https://ipapi.co/${data.ip}/country/`)
        .then(response => response.text())
        .then(country => {
            // Check if the user is in India
            if (country.trim().toLowerCase() !== 'in') {
                // Redirect to another domain if user is not in India
                window.location.href = 'https://www.holygrailhomes.com'; // Replace 'https://example.com' with the domain you want to redirect to
            }
        })
        .catch(error => {
            console.error('Error fetching country:', error);
        });
    })
    .catch(error => {
        console.error('Error fetching IP address:', error);
    });
}

// Call the function to check user's location
isInIndia();

